import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true est ce qui permet au cookie de connexion partagé
// (posé par lafribue.fr, Domain=.lafribue.fr) d'être envoyé automatiquement
// ici - c'est la base de la connexion unique entre les deux sites.
const instance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default instance;
